module.exports = __webpack_public_path__ + "img/payicon_exim.0dbe4306.png";